/* template */
<template minapp="mpx" xlang="wxml"><div class="scramble-contact-person-wrap"><div v-for="(item, index) in (passengers)" class="item"><div class="name">{{item.passenger_name}}</div><div class="id">{{item.passenger_id_type_name}} {{ item.passenger_id_no }}</div><div class="line"></div></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m35d8bbdf"}'>
  @import '~@/mixins/stylus/color.styl'
  .scramble-contact-person-wrap
    background #FFFFFF
    border-radius 8px
    margin-bottom 8px
    .item
      padding 16px 11px
      position relative
      .name
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 16px
        letter-spacing 0px
        color #000000
        margin-bottom 8px
      .id
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 14px
        letter-spacing 0px
        color #999999
      .line
        position absolute
        bottom 0
        left 12px
        width calc(100% - 24px)
        height 0.5px
        background #F0F1F4


</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m35d8bbdf"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./scramble-contact-person.mpx.js?isComponent&outputPath=components%2Fscramble-contact-person35d8bbdf%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./scramble-contact-person.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fscramble-contact-person35d8bbdf%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m35d8bbdf"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/scramble-contact-person35d8bbdf/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
